export default class StTextAccessor {
	
  constructor(nodeName, serviceName, authAndHostResolver)
  {
      this.serviceName = serviceName;
      this.authAndHostResolver = authAndHostResolver;

      this.STTEXT_BASE_URI = `/service/invoke?service=${nodeName&&(nodeName+'.')||''}STText.${serviceName}&requestFormat=JSON;notation=type;notationLevel=none&responseFormat=JSON;notation=type;notationLevel=none`;
      this.START_TRANSCRIPTION_URI = `${this.STTEXT_BASE_URI}&eventHandler=startTranscription`;
      this.END_TRANSCRIPTION_URI = `${this.STTEXT_BASE_URI}&eventHandler=endTranscription`;
      this.SUBMIT_WAV_BYTES_URI = `${this.STTEXT_BASE_URI}&eventHandler=submitWavBytes`;
  }

  startTranscription(request = {
      conversationId: null,
      type: null,
      transcriptFilePath: null,
      wavFilePath: null,
      explain: false,
      punctuationParams: {
          punctuationAlgorithm: 'BERT',
          commaDelayMs: -1,
          dotDelayMs: -1,
          newLineDelayMs: 1500,
          collectionTimeMs: 5000
      }
  }) {
    if (!request) {
        request = {}
    }

    const url = this.authAndHostResolver(this.START_TRANSCRIPTION_URI);
    const payload = JSON.stringify(request);

    return this.executePost(url, payload);
  }

  submitWavBytes(request = {
      conversationId: null,
      bytes: null,
      audioFormat: null,
      sync: false
  }) {
    if (request.audioFormat && request.audioFormat.properties) {
        request.audioFormat.properties = null;
    }

    const url = this.authAndHostResolver(this.SUBMIT_WAV_BYTES_URI);
    const payload = JSON.stringify(request);

    return this.executePost(url, payload);
  }

  endTranscription(request = {
      conversationId: null
  }) {

    const url = this.authAndHostResolver(this.END_TRANSCRIPTION_URI);
    const payload = JSON.stringify(request);

    return this.executePost(url, payload);
  }

  executePost(url, payload) {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('POST', url, true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onload = () => {
            if (xhr.status === 200) {
                resolve(JSON.parse(xhr.responseText));
            } else {
                reject(xhr.responseText ? JSON.parse(xhr.responseText) : xhr.statusText)
            }
        };

        xhr.onerror = () =>
            reject(xhr.statusText);
        xhr.send(payload);
    });
  }
}